<template>
  <div class="relative mb-8">
    <!-- Navbar Başlangıç -->

    <div class="vx-navbar-wrapper">
      <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->

      <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->
      <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj" collapse>
        <div slot="title">
          <!-- <vs-navbar-title>   
            <h6>NAVBAR TITLE</h6>
          </vs-navbar-title> -->
          <div class="work-times tFlex flex_jc-sb">
            <div class="flex tFlex_ai-c">
              <div v-if="CheckAuthorizationOfRouter('HomeMenu')" class="cursor-pointer home-icon mr-3" @click="$router.push('/HomeMenu').catch((err) => {})">
                <feather-icon icon="HomeIcon" class="text-warning" svgClasses="h-full w-full" />
              </div>
              <template v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '21') != null || (hrShiftIpList && hrShiftIpList.filter((p) => p.ipAddress == ipResult).length > 0)">
                <template v-if="hrShiftList == null || (hrShiftList[0].start != null && hrShiftList[0].finish != null)">
                  <div class="time-start">
                    <div class="button" @click="StartStopShift('Start')">
                      <feather-icon icon="PlayIcon" svgClasses="h-full w-full" />
                      <div class="for-desktop ml-2">Mesai Başlat</div>
                    </div>
                    <div class="time">
                      <div class="">Çalışma: {{ workingTimeDesc }}</div>
                      <div class="">Mola: {{ permissionTime }}</div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="time-stop">
                    <div class="button" @click="StartStopShift('Stop')">
                      <feather-icon readonly="true" icon="PauseIcon" svgClasses="h-full w-full " />
                      <div class="for-desktop ml-2">Mesai Bitir</div>
                    </div>
                    <div class="time">
                      <div class="">Çalışma: {{ workingTimeDesc }}</div>
                      <div class="">Mola: {{ permissionTime }}</div>
                    </div>
                  </div>
                </template>
              </template>

              <template v-else>
                <div class="">Bu Ip den mesai işlemi yapamazsınız</div>
              </template>

              <vs-prompt
                style="z-index: 100001;"
                v-if="selectedPopupDate"
                :vs-title="
                  'Çalışma Bilgileri İşlemleri # ' +
                  momentFunction(selectedPopupDate).format('DD.MM.YYYY') +
                  ' ' +
                  momentFunction(selectedPopupDate).locale('tr').format('ddd') +
                  ' ( ' +
                  momentFunction(selectedPopupDate).week() +
                  ' . Haftanın ' +
                  momentFunction(selectedPopupDate).day() +
                  ' . günü ) ' +
                  ' - Saat ' +
                  ('' + selectedPopupHour).padStart(2, '0') +
                  ':00 - ' +
                  ('' + (selectedPopupHour + 1)).padStart(2, '0') +
                  ':00 Arası '
                "
                vs-accept-text="Kaydet"
                vs-cancel-text="Kapat"
                @vs-close="continueShift()"
                vs-button-cancel="border"
                :vs-active.sync="popupTimesheetTransaction"
                :vs-buttons-hidden="true"
              >
                <div class="vx-row w-full mb-5">
                  <div class="vx-col md:w-1/2">
                    <b><vs-checkbox v-model="reflectToOtherHourEnabled">Bu Çalışmayı Seçilen Saatlere de Yansıt</vs-checkbox></b>
                  </div>
                  <div class="vx-col md:w-1/2" v-if="reflectToOtherHourEnabled">
                    <vs-radio vs-value="EightToSixteen" vs-name="PreDefinedHour" v-model="preDefinedHour" @change="SetReflectionHour(8, 18)">8:00 - 18:00</vs-radio>
                    <vs-radio vs-value="NineToSeventeen" vs-name="PreDefinedHour" v-model="preDefinedHour" @change="SetReflectionHour(9, 19)">9:00 - 19:00</vs-radio>
                    <vs-radio vs-value="TenToTwenty" vs-name="PreDefinedHour" v-model="preDefinedHour" @change="SetReflectionHour(10, 20)">10:00 - 20:00</vs-radio>
                    <vs-radio vs-value="ElevenToTwentyOne" vs-name="PreDefinedHour" v-model="preDefinedHour" @change="SetReflectionHour(11, 21)">11:00 - 21:00</vs-radio>
                  </div>
                </div>

                <div class="vx-row w-full mt-5" v-if="reflectToOtherHourEnabled">
                  <div v-for="tr in reflectionList" :key="tr.hour" class="vx-col md:w-1/6 w-full mb-2">
                    <template v-if="tr.hour != selectedPopupHour">
                      <vs-checkbox v-model="tr.selected">{{ tr.hour + ":00 - " + (tr.hour + 1) + ":00" }}</vs-checkbox>
                    </template>
                    <template v-else>
                      <b class="primary"> Seçilen Saat</b>
                    </template>
                  </div>
                </div>

                <div class="vx-row w-full">
                  <div class="vx-col mb-5 w-full">
                    <label class="text-sm"><b>Çalışılan Proje</b></label>
                    <v-select
                      name="hrProjectName"
                      @input="
                        timesheetItem.hrProjectAssignId = $event.hrProjectAssignId;
                        timesheetItem.hrProjectId = $event.hrProjectId;
                      "
                      placeholder="Proje"
                      :options="projectList"
                      label="name"
                    >
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </div>
                </div>

                <div class="vx-row w-full">
                  <div class="vx-col mb-5 w-full md:w-4/4">
                    <label class="text-sm"><b>Çalışma Açıklaması</b></label>
                    <vs-textarea rows="1" v-model="timesheetItem.description" name="description" />
                  </div>
                </div>

                <div class="vx-row w-full mb-5" style="justify-content: center; align-items: center;">
                  <vs-button v-if="$store.state.userData.userId == searchTimesheet.userId" color="danger" @click="SaveHRTimesheet(timesheetItem, 'Insert', '')">Çalışma Ekle</vs-button>
                </div>

                <div class="vx-row w-full mb-5">
                  <div class="vx-row w-full">
                    <div class="vx-col w-full">
                      <vs-table v-if="selectedTimesheetItem" :maxItems="10" :pagination="true" :data="selectedTimesheetItem">
                        <template slot="thead">
                          <vs-th>Id</vs-th>
                          <vs-th>Çalışılan Proje ve Görev</vs-th>
                          <!-- <vs-th>Saat</vs-th> -->
                          <vs-th>Çalışma Açıklama</vs-th>
                          <vs-th>Kayıt Bilgileri</vs-th>

                          <!-- <vs-th style="width:150px">Kayıt Auto Link</vs-th> -->

                          <vs-th>İşlemler</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr :key="tr.hrTimesheetId" v-for="(tr, i) in data">
                            <template>
                              <vs-td class="pt-0 pb-1">{{ tr.hrTimesheetId }}</vs-td>
                              <vs-td class="pt-0 pb-1" style="width: 250px;">
                                <template v-if="tr.hrProjectName">
                                  {{ tr.hrProjectName + " - " + tr.hrProjectDescription + " - " + tr.hrProjectAssignDescription }}
                                </template>
                              </vs-td>
                              <!-- <vs-td class="pt-0 pb-1" style="width:250px">
                      <vs-input readonly="true" type="text" v-model="tr.hour" />
                    </vs-td> -->
                              <vs-td class="pt-0 pb-1" style="width: 250px;">
                                <vs-textarea :readonly="tr.entryType != 'User'" type="text" v-model="tr.description" />
                              </vs-td>

                              <vs-td class="pt-0 pb-1" style="flex-flow: nowrap;">
                                {{ tr.entryType + " - " + tr.assignerUserName + " - " + tr.ipAddress }}
                              </vs-td>
                              <!-- <vs-td class="pt-0 pb-1" style="width:100px">
                      <template v-if="tr.entryType == 'User'">Kullanıcı girişi</template>
                      <template v-else>
                        <a href="" style="color: red; font-size: 10px;"
                          ><b class="mr-5">{{ tr.moduleId }}</b></a
                        >
                      </template>
                    </vs-td> -->

                              <td>
                                <div v-if="$store.state.userData.userId == searchTimesheet.userId && tr.assignStatus != 'Completed'" style="flex-flow: nowrap; width: max-content;">
                                  <a v-if="tr.entryType == 'User'" href="" @click.prevent="SaveHRTimesheet(tr, 'Update', '')" style="color: orange; font-size: 10px;"><b class="mr-5">Güncelle</b></a>
                                  <a v-if="tr.entryType == 'User'" href="" @click.prevent="SaveHRTimesheet(tr, 'Delete', '')" style="color: red; font-size: 10px;"><b class="mr-5">Sil</b></a>

                                  <a href="" v-if="tr.assignStatus != 'Completed'" @click.prevent="SaveHRProjectAssign(tr, 'Update', 'Görev taskı tamamlanacak atayan kişi mail ile bilgilendirilecektir.')" style="color: #7393b3; font-size: 10px;"
                                    ><b class="mr-5">Görevi Tamamla</b></a
                                  >
                                </div>
                              </td>
                            </template>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </vs-prompt>
              <!-- <div class="">{{ " ( Ip Addresiniz : " + ipResult + " )" }}</div> -->
            </div>
            <!-- Profil Start -->
            <div class="flex tFlex_ai-c gap-2">
              <div v-if="CheckAuthorizationOfRouter('Products')" class="for-desktop cursor-pointer" @click="$router.push('/Products').catch((err) => {})"><feather-icon icon="ArchiveIcon" class="stoke-current text-warning" /></div>
              <div v-if="CheckAuthorizationOfRouter('Sales')" class="for-desktop cursor-pointer" @click="$router.push('/Sales').catch((err) => {})"><feather-icon icon="ShoppingBagIcon" class="stoke-current text-warning" /></div>
              <div v-if="CheckAuthorizationOfRouter('HRTimesheet')" class="for-desktop cursor-pointer" @click="$router.push('/HRTimesheet').catch((err) => {})"><feather-icon icon="CalendarIcon" class="stoke-current text-warning" /></div>
              <div v-if="CheckAuthorizationOfRouter('SaleWizard')" class="vx-col">
                <feather-icon icon="ShoppingCartIcon" svgClasses="h-full w-full mr-2 hover:text-primary cursor-pointer" title="Sepetim" @click="$router.push('/SaleWizard').catch((err) => {})" />
              </div>

              <i style="cursor: pointer; font-size: 36px;" @click="SaveUserTheme('light')" class="material-icons-outlined">light_mode</i>
              <i style="cursor: pointer; font-size: 36px;" @click="SaveUserTheme('semi-dark')" class="material-icons-outlined">brightness_4</i>
              <i style="cursor: pointer; font-size: 36px;" @click="SaveUserTheme('dark')" class="material-icons-outlined">dark_mode</i>

              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <div>
                  <feather-icon icon="BellIcon" class="cursor-pointer mr-2" :badge="loaded ? unreadNotifications.length : ''"></feather-icon>
                </div>
                <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
                  <div class="notification-top text-center bg-primary text-white">
                    <h3 class="text-white">Bildirimler</h3>
                    <p class="opacity-75">
                      {{ unreadNotifications.length > 0 ? unreadNotifications.length + " yeni bildiriminiz var!" : "Hiç yeni bildiriminiz yok" }}
                    </p>
                  </div>
                </vs-dropdown-menu>
              </vs-dropdown>
              <div class="the-navbar__user-meta flex items-center">
                <div class="text-right leading-tight hidden sm:block">
                  <div class="responsive">
                    <p class="font-semibold">Selam, {{ user_displayName.userName }}</p>
                    <small>{{ user_displayName.userTeam }}</small>
                  </div>
                </div>
                <!-- Profil Dropdown Başlangıç -->
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <div class="con-img ml-3">
                    <img key="onlineImg" :src="picture != null && picture.length > 457 ? picture : this.$defaultPicture" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
                  </div>
                  <vs-dropdown-menu class="vx-navbar-dropdown">
                    <ul style="min-width: 9rem;">
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/userEdit/' + $store.state.userData.userId).catch((err) => {})">
                        <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                        <span class="ml-2">Profil</span>
                      </li>
                      <vs-divider class="m-1"></vs-divider>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/staffRequests').catch((err) => {})">
                        <feather-icon icon="LayersIcon" svgClasses="w-4 h-4"></feather-icon>
                        <span class="ml-2">Talepler</span>
                      </li>
                      <vs-divider class="m-1"></vs-divider>
                      <li v-if="CheckAuthorizationOfRouter('OrganizationalChart')" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/organizationalchart').catch((err) => {})">
                        <feather-icon icon="LayersIcon" svgClasses="w-4 h-4"></feather-icon>
                        <span class="ml-2">Şirket Hiyerarşisi</span>
                      </li>
                      <vs-divider class="m-1"></vs-divider>
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout()">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                        <span class="ml-2"> Çıkış Yap </span>
                      </li>
                    </ul>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <!-- Profil Dropdown Son -->
              </div>
            </div>
            <!-- Profil End -->
          </div>
        </div>
        <vs-navbar-item index="0">
          <div class="mobil-tab-menu">
            <div v-if="CheckAuthorizationOfRouter('Sales')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/Sales').catch((err) => {})">
              <feather-icon icon="ShoppingBagIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Satışlar</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('UserList')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/userList').catch((err) => {})">
              <feather-icon icon="UsersIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Personel Listesi</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('ReturnRequest')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/ReturnRequests').catch((err) => {})">
              <feather-icon icon="TruckIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>İade İstekleri</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('TechnicService')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/TechnicService').catch((err) => {})">
              <feather-icon icon="CpuIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Teknik Servis</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('Products')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/Products').catch((err) => {})">
              <feather-icon icon="ArchiveIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Ürünler</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('AccountMovement')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/AccountMovement').catch((err) => {})">
              <feather-icon icon="CrosshairIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Aksiyon Hareketleri</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('MoneyTransfer')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/MoneyTransfer').catch((err) => {})">
              <feather-icon icon="DollarSignIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Para Transferleri</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('AccountDashboard')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/AccountDashboard').catch((err) => {})">
              <feather-icon icon="ActivityIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Mali Tablo</b>
            </div>
            <div
              v-if="CheckAuthorizationOfRouter('SendSms')"
              class="vx-col cursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c"
              @click="$router.push('/CustomerCommentByUserId/' + $store.state.userData.userId).catch((err) => {})"
            >
              <feather-icon icon="SendIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>Sms Gönder</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('Contacts')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/Contacts').catch((err) => {})">
              <feather-icon icon="UserCheckIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Müşteriler</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('HRProject')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/HRProject').catch((err) => {})">
              <feather-icon icon="FileTextIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Projeler</b>
            </div>
            <div
              v-if="CheckAuthorizationOfRouter('HRProjectByAssignUserId')"
              class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c"
              @click="$router.push('/HRProjectByAssignUserId/' + $store.state.userData.userId).catch((err) => {})"
            >
              <feather-icon icon="FilePlusIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Görev Atanan Projeler</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('HRTimesheet')" class="cursor-pointer icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/HRTimesheet').catch((err) => {})">
              <feather-icon icon="CalendarIcon" class="stoke-current text-warning cursor-pointer p-2" />
              <b>Haftalık Plan</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('Permission')" class="vx-colcursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/Permission').catch((err) => {})">
              <feather-icon icon="FileIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>İzin Talep</b>
            </div>
            <div v-if="CheckAuthorizationOfRouter('Management')" class="vx-col cursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c" @click="$router.push('/management').catch((err) => {})">
              <feather-icon icon="UserPlusIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>Talep Onay</b>
            </div>
            <div
              v-if="CheckAuthorizationOfRouter('SupportTicket')"
              class="vx-col cursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c"
              @click="$router.push('/SupportTicket').catch((err) => {})"
            >
              <feather-icon icon="PhoneForwardedIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>Ticket</b>
            </div>
            <div
              v-if="CheckAuthorizationOfRouter('SupportTicketByUserId')"
              class="vx-col cursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c"
              @click="$router.push('/SupportTicketByUserId').catch((err) => {})"
            >
              <feather-icon icon="PhoneIncomingIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>Açtığım Ticket</b>
            </div>
            <div
              v-if="CheckAuthorizationOfRouter('SupportTicketByAssignUserId')"
              class="vx-col cursor-pointer icon m-3 p-5 vx-col md:w-1/6 w-full icon m-3 p-3 card-bg tFlex tFlex_column tFlex_jc-c tFlex_ai-c"
              @click="$router.push('/SupportTicketByAssignUserId').catch((err) => {})"
            >
              <feather-icon icon="PhoneOutgoingIcon" class="stoke-current text-warning cursor-pointer p-1" />
              <b>Atanan Ticket</b>
            </div>
          </div>
        </vs-navbar-item>

        <!-- 
          Turuncu İkonlar Başlangıç
         -->

        <!-- <div class="vx-row" style="align-items: center;">

          <div class="vx-col">
            <a :href="'/HRProjectByAssignUserId/' + $store.state.userData.userId" style="margin-left: 15px; color: dark red; white-space: nowrap;"><b>Görev Atanan Projeler</b></a>
          </div>

          <div class="vx-col">
            <a href="/HRTimesheet" style="margin-left: 15px; white-space: nowrap;"><b>Haftalık Plan</b></a>
          </div>
        </div> -->
        <!-- 
          Turuncu İkonlar Son
         -->
        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->

        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->

        <!-- SEARCHBAR -->
        <!-- <div class="search-full-container w-full h-full absolute left-0 rounded-lg" :class="{ flex: showFullSearch }" v-show="showFullSearch">
          <vx-auto-suggest
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            @selected="selected"
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            placeholder="Search..."
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border"
            icon="SearchIcon"
            background-overlay
          ></vx-auto-suggest>
          <div class="absolute right-0 h-full z-50">
            <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
          </div>
        </div> -->
        <!-- <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4"></feather-icon> -->
        <!-- NOTIFICATIONS -->
        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->

        <!-- Bildirim Çanı Başlangıç -->

        <!-- Bildirim Çanı Son -->
        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------- -->
        <!-- USER META -->
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import { authenticationService } from "../../_services/authentication.service";
import router from "../../router";
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  created: async function () {
    // this.getNotifications();
    // const a = setInterval(this.getNotifications, 30000);
    // repository.timers(a, "notification");
    this.toggleClassInBody(this.$store.state.theme);
    await Promise.all([this.GetPersonnelImageStream(), this.GetClientIpAddress(), this.StartStopShift("GetHRShift"), this.GetHRShiftIpList(), this.GetHRProject()]);
  },
  data() {
    return {
      themeList: [
        { id: "light", themeName: "Açık Renk" },
        { id: "semi-dark", themeName: "Yarı Koyu Renk" },
        { id: "dark", themeName: "Koyu Renk" },
      ],
      selectedPopupDate: null,
      selectedPopupHour: null,

      popupTimesheetTransaction: false,
      reflectToOtherHourEnabled: false,
      preDefinedHour: "",
      selectedTimesheetItem: null,
      timesheetItem: null,
      projectList: [{ hrProjectId: undefined, projectName: null, departmentId: null, fileList: [] }],
      searchTimesheet: { hrProjectId: null, projectName: null, departmentId: null, fileList: [], timesheetDate: new Date(), userId: this.$store.state.userData.userId, dateList: [] },
      projectAssignList: [{ hrProjectId: null, projectName: null, departmentId: null, fileList: [] }],

      selectedProjectItem: {},
      momentFunction: this.$moment,
      reflectionList: [
        { hour: 0, selected: false },
        { hour: 1, selected: false },
        { hour: 2, selected: false },
        { hour: 3, selected: false },
        { hour: 4, selected: false },
        { hour: 5, selected: false },
        { hour: 6, selected: false },
        { hour: 7, selected: false },
        { hour: 8, selected: false },
        { hour: 9, selected: false },
        { hour: 10, selected: false },
        { hour: 11, selected: false },
        { hour: 12, selected: false },
        { hour: 13, selected: false },
        { hour: 14, selected: false },
        { hour: 15, selected: false },
        { hour: 16, selected: false },
        { hour: 17, selected: false },
        { hour: 18, selected: false },
        { hour: 19, selected: false },
        { hour: 20, selected: false },
        { hour: 21, selected: false },
        { hour: 22, selected: false },
        { hour: 23, selected: false },
      ],

      activeSidebar: true,
      workingTimeDesc: null,
      permissionTime: null,
      ipResult: null,
      hrShiftList: null,
      hrShiftIpList: [{ ip: null }],
      hrShiftItem: { finish: null, start: null, userId: null, description: "Mesai Başlatılmadı" },
      picture: "",
      loaded: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [
        {
          id: 0,
          index: 0,
          title: "",
          message: "",
          icon: "",
          time: "",
          category: "",
          senderName: "",
          link: "",
        },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
    };
  },

  computed: {
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // PROFILE
    user_displayName() {
      return this.$store.state.userData;
    },
  },
  methods: {
    continueShift: async function () {
      router.push({ path: "HRShift" });
    },
    SetReflectionHour: async function (start, finish) {
      this.reflectionList.forEach((p) => {
        if (p.hour < start || p.hour > finish || p.hour == this.selectedPopupHour) p.selected = false;
        else p.selected = true;
      });
    },
    GetHRProject: async function () {
      this.$vs.loading();
      this.projectList = await repository.postEntity("HumanResource/GetHRProjectAssign", { assignUserId: this.searchTimesheet.userId, status: "Active", AssignStatus: "Assigned" }).then((r) => r.list);
      this.$vs.loading.close();
    },
    GetHRProjectById: async function (hrProjectId) {
      return await repository.postEntity("HumanResource/GetHRProject", { hrProjectId: hrProjectId }).then((r) => r.list[0]);
    },

    GetHRProjectAssign: async function () {
      this.$vs.loading();
      this.projectAssignList = await repository.postEntity("HumanResource/GetHRProjectAssign", this.selectedProjectItem).then((r) => r.list);
      this.$vs.loading.close();
    },
    SaveHRTimesheet: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;
      // item.hrProjectId = this.selectedProjectItem.hrProjectId;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      item.userId = this.searchTimesheet.userId;

      if (item.userId != this.$store.state.userData.userId) {
        item.entryType = "Assign";
      } else {
        item.entryType = "User";
      }

      await repository.postEntity("HumanResource/SaveHRTimesheet", item);

      //Yapılan çalışmayı diğer saatlere yansıtma işlemi yapar
      if (operation == "Insert" && this.reflectToOtherHourEnabled) {
        for (const reflectRow of this.reflectionList) {
          if (reflectRow.selected) {
            item.hour = reflectRow.hour;
            await repository.postEntity("HumanResource/SaveHRTimesheet", item);
          }
        }
      }

      this.$vs.loading.close();

      let resultConfirm = await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      //this.GetTimesheetList("Current");
      this.popupTimesheetTransaction = false;
      this.reflectToOtherHourEnabled = false;
      this.reflectionList.forEach((p) => (p.selected = false));

      if (resultConfirm.isConfirmed) router.push({ path: "HRShift" });
    },

    SaveHRProjectAssign: async function (item, operation, messageText) {
      item.assignStatus = "Completed";
      item.finishDate = this.$moment().format("l LT");
      //Insert,Update,Delete
      item.operation = operation;
      item.hrProjectId = this.selectedProjectItem.hrProjectId;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("HumanResource/SaveHRProjectAssign", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.GetHRProjectAssign();
    },

    SaveUserTheme: async function (themeName) {
      this.$store.dispatch("updateTheme", themeName);
      await repository.postEntity("HumanResource/SaveUserTheme", { userId: this.$store.state.userData.userId, themeName: this.$store.state.theme });
    },

    StartStopShift: async function (action) {
      if (action == "Start" || action == "Stop") {
        let resultConfirm2 = await this.$swal.fire({
          icon: "warning",
          //title: action == "Start" ? "Mesai süresi başlatılacaktır devam etmek istediğinize emin misiniz?" : "Mesai bitirilecektir. Devam etmek istediğinize emin misiniz? Çalışma süreniz " + this.workingTimeDesc,
          text: action == "Start" ? "Mesai süresi başlatılacaktır devam etmek istediğinize emin misiniz?" : "Mesai bitirilecektir. Devam etmek istediğinize emin misiniz? Çalışma süreniz " + this.workingTimeDesc,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        if (resultConfirm2.isConfirmed) null;
        else return;
      }

      //proje popup açılacak
      let index = this.$moment().hours();
      let weekDay = this.$moment().day();
      let momentValue = this.$moment();

      let timesheetIsExist = this.GetTimesheetDetailList(index, weekDay, momentValue);
      this.selectedPopupDate = this.$moment();
      this.selectedPopupHour = this.$moment().hours();

      if (timesheetIsExist) {
        this.selectedTimesheetItem = timesheetIsExist;
        this.timesheetItem = {
          hrTimesheetId: timesheetIsExist[0].hrTimesheetId,
          entryType: "User",
          hrProjectId: null,
          operation: "Insert",
          hour: index,
          timesheetDate: this.$moment(this.selectedPopupDate).format(),
        };
      } else {
        this.timesheetItem = { entryType: "User", hrProjectId: null, operation: "Insert", hour: index, timesheetDate: this.$moment(this.selectedPopupDate).format() };
        this.selectedTimesheetItem = null;
      }

      if (action == "Start" && this.$store.state.userData.departmentId == 1) this.popupTimesheetTransaction = true;

      ///////////////////////////////////
      this.hrShiftList = await repository.postEntity("HumanResource/OperateUserShift", { operation: action }).then((r) => r.list);
      //O güne ait hiç mesai başlamımış ise null çekilerek time durdurluyor
      if (this.hrShiftList.length == 0) this.hrShiftList = null;

      if (action == "Stop") router.push({ path: "HRShift" });
    },

    GetTimesheetDetailList: function (index, weekDay, momentValue) {
      //İndex burda saat demektir
      //Tarih momentValue demektir

      if (this.timesheetList == null || Object.keys(this.timesheetList).length == 0) return false;

      let matchTimeSheetList = this.timesheetList.filter((row) => row.weekDay == weekDay && this.$moment(row.timesheetDate).isSame(momentValue) && row.hour == index);

      if (matchTimeSheetList == null || Object.keys(matchTimeSheetList).length == 0) return null;

      //çalışma saati tespit ediliyor. Çalışma saati yoksa null dönülerek component v-if e girmeyecek ve hata vermeyecek

      return matchTimeSheetList;
    },
    GetTimeSheetWorkingStr: function (index, weekDay, momentValue) {
      let detailList = this.GetTimesheetDetailList(index, weekDay, momentValue);

      let workingDescription =
        "<i class='material-icons-outlined mr-5 success'>article</i><b class='success' style='vertical-align: super;'>" + detailList.filter((r) => r.userId == r.assignerUserId).length + " Adet çalışma kaydı vardır " + "</b> <br/>";
      // workingDescription += "<b style='color:blue;'>" + detailList.filter((r) => r.userId != r.assignerUserId).length + " Adet Görev Ataması Vardır " + "</b> <br/>";

      let concatenateWorking = detailList.reduce((previousValue, element) => {
        return previousValue + (element.description != null ? element.description + "<br/> " : "");
      }, "");
      return workingDescription + concatenateWorking;
    },
    CalculateWorkingTime: async function () {
      if (this.hrShiftList == null) return;

      this.permissionTime = this.$moment.utc(this.hrShiftList[0].permissionDuration * 1000).format("HH:mm:ss");

      if (this.hrShiftList != null && this.hrShiftList.length > 0 && this.hrShiftList[0].finish == null) {
        var a = this.$moment();
        var b = this.$moment(this.hrShiftList[0].start);

        this.workingTimeDesc = this.$moment.utc((this.hrShiftList[0].workingDuration + a.diff(b, "seconds")) * 1000).format("HH:mm:ss");
      } else if (this.hrShiftList != null && this.hrShiftList.length > 0 && this.hrShiftList[0].finish != null) {
        this.workingTimeDesc = this.$moment.utc(this.hrShiftList[0].workingDuration * 1000).format("HH:mm:ss");
      } else {
        this.workingTimeDesc = this.$moment.utc(this.hrShiftList[0].workingDuration * 1000).format("HH:mm:ss");
      }
      this.$store.state.userData.workingTimeDesc = this.workingTimeDesc;
    },
    GetHRShiftIpList: async function () {
      this.hrShiftIpList = await repository.postEntity("HumanResource/GetHRShiftIpList", {}).then((r) => r.list);
    },

    GetClientIpAddress: async function () {
      await fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.ipResult = ip;
        });
    },

    GetPersonnelImageStream: async function () {
      let a;
      this.picture = null;
      this.picture = await repository
        .DownloadStream("HumanResource/DownloadPersonnelPicture" + "/" + this.$store.state.userData.userId)

        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((callback) => {
              let reader = new FileReader();
              reader.onload = function () {
                callback(this.result);
              };
              reader.readAsDataURL(blob);
            })
        );

      return this.picture;
    },

    goToPage() {
      window.location.href = "/userView/" + this.user_displayName.userId;
    },
    logout() {
      authenticationService.logout();
      router.push("/login").catch((err) => {
        console.warn(err);
      });
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url).catch((err) => {
        console.warn(err);
      });
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
  },

  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
    vSelect,
  },

  mounted: async function () {
    window.setInterval(() => {
      this.CalculateWorkingTime();
    }, 1000);
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.popupTimesheetTransaction = false;
      }
    });
  },
};
</script>

<style lang="scss">
.responsive {
  @media screen and (max-width: 1366px) {
    width: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.bookmark-container {
  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
